module.exports = __webpack_public_path__ + "static/media/demoBanner.64762dcb.svg";